
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 96 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_28849_1127)","fill":"currentColor"}},[_c('path',{attrs:{"d":"M48.501 1.824c-3.79 0-7.224 1.588-9.71 4.155-2.486 2.562-4.023 6.108-4.023 10.023 0 3.912 1.537 7.455 4.023 10.018 2.486 2.565 5.92 4.155 9.71 4.155 3.792 0 7.227-1.59 9.709-4.155 2.485-2.563 4.018-6.106 4.018-10.018 0-3.915-1.533-7.46-4.019-10.023-2.481-2.567-5.916-4.155-9.708-4.155zm0-1.717c8.502 0 15.396 7.117 15.396 15.895 0 8.775-6.894 15.891-15.396 15.891-8.501 0-15.398-7.116-15.398-15.891C33.103 7.224 40 .107 48.501.107z"}}),_c('path',{attrs:{"d":"M41.22 15.873c0-.927-.596-1.453-1.44-1.453h-.515v2.906h.501c.784 0 1.453-.44 1.453-1.454zm9.175 1.045l-3.8 3.089-3.473-2.823a3.356 3.356 0 01-3.107 2.106h-2.973v-6.835h2.973c1.558 0 2.681 1.023 3.106 2.113l3.474-2.82 1.287 1.045-3.184 2.584.611.494 3.184-2.582 1.288 1.043-3.183 2.586.61.495 3.187-2.587v-2.371h2.31v4.84h2.305v2.003h-4.615v-2.38zm7.54.378h2.304v2.003h-4.616v-6.844h2.313v4.841z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_28849_1127"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(33)","d":"M0 0h31v32H0z"}})])])])
          )
        }
      }
    